import { COMMON_UI_I18N } from "./commonUiI18n";
import { FILE_VALIDATION_I18N } from "./fileValidationI18n";

const ACCEPTED_FORMATS_LABEL = `Sélectionnez des documents ${FILE_VALIDATION_I18N.ACCEPTED_FORMATS_SHORT}`;

export const FILE_UPLOAD_TEXTS = {
	generic: {
		addDocumentCta: "Ajouter un document",
		browseCta: "parcourir",
	},
	modal: {
		title: "Ajouter un document",
		confirmCta: "Déposer le document",
		loadingCta: "Chargement...",
		cancelCta: COMMON_UI_I18N.modal.cancelCta,
	},
	otherDocuments: {
		intro: "Vous souhaitez envoyer un autre document à votre notaire ?",
		instructions:
			"Glissez / Déposez votre document dans la zone prévue à cet effet ou cliquez sur la zone puis sélectionnez le document correspondant.",
		acceptedFormats: ACCEPTED_FORMATS_LABEL,
	},
	rib: {
		inputAriaLabel: "Ajouter un RIB",
		title: "Déposer un RIB",
		intro: "Glissez / Déposez votre RIB dans la zone prévue ou cliquez pour sélectionner.",
		acceptedFormats: ACCEPTED_FORMATS_LABEL,
	},
	sendDocuments: {
		title: "Glisser ou déposer ou",
		intro: "Glissez / Déposez vos documents dans la zone prévue ou cliquez pour sélectionner.",
		acceptedFormats: ACCEPTED_FORMATS_LABEL,
		tooManyTitle: "Trop de fichiers",
		tooLargeTitle: "Envoi trop volumineux",
		unknownError: "Erreur inconnue lors de l'envoi",
		impossibleTitle: "Envoi impossible",
		partialTitle: "Documents partiellement envoyés",
		bitcoinUnavailableTitle: "Horodatage sécurisé indisponible",
	},
} as const;

export function getUploadTextScope<TScope extends keyof typeof FILE_UPLOAD_TEXTS>(
	scope: TScope,
): (typeof FILE_UPLOAD_TEXTS)[TScope] {
	return FILE_UPLOAD_TEXTS[scope];
}
